/**
 * Module « tarification » — TAR-01 à TAR-04.
 *
 * Grilles tarifaires par saison, saisie matricielle zone × catégorie de
 * public (par spectacle et par formule), copie de matrice, indicateur de
 * complétude (pastille rouge par spectacle/formule incomplet).
 */

import { lazy } from 'react'
import type { RouteObject } from 'react-router'

const PageTarification = lazy(() =>
  import('./PageTarification').then((m) => ({ default: m.PageTarification })),
)

export const routesTarification: RouteObject[] = [
  {
    index: true,
    element: <PageTarification />,
  },
]
